import { childPickupBehaviorIds } from '@famly/vet_child-pickup-behavior-ids';
/** Core adds the behaviour where the room and site both ask; a room asking on its own also counts */
export const childRequiresPickupInfo = (behaviorIds, group) => behaviorIds.includes(childPickupBehaviorIds.RequiresPickupInfo) || Boolean(group === null || group === void 0 ? void 0 : group.requirePickupInfo);
